<div #mapContainer id="map"></div>
